import { render } from "./LinkText.vue?vue&type=template&id=2e00b464"
import script from "./LinkText.vue?vue&type=script&lang=js"
export * from "./LinkText.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__